import { Box, Grid, MenuItem, Select, TextField, Stack, Button, Autocomplete } from '@mui/material';
import React, { useState, useEffect } from 'react'
import { ErrorTypography, SecondaryTypography, StyledTypography } from '../../Theme';
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import { NameRegex, No_special_regex } from '../../Utils';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axiosInstance from '../../Redux/AxiosInstance';
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { create } from '@mui/material/styles/createTransitions';
import PhoneInput from 'react-phone-input-2';

function AddUser() {

    const navigate = useNavigate()
    const { userDetails } = useSelector((state) => state.Login);
    console.log(userDetails)
    const initialDeviceData = {
        name: "",
        email: "",
        phone: "",
        role_id: "",
        sub_user_role : ""        
    }
    const [PersonalDetailsData, setPersonalDetailsData] = useState({
        ...initialDeviceData
      });

      const {id} = useParams();
      const location = useLocation();
      const {deviceData} = location.state || {};

      useEffect(() => {
        if(id && deviceData){
            setPersonalDetailsData({
                name: deviceData.name || "",
                email: deviceData.email || "",
                phone: deviceData.phone || "",
                role_id: deviceData.role_id || "",
                sub_user_role: deviceData?.sub_user_role || "",
            });
        }
      }, [id, deviceData]);

      console.log(deviceData)


      const [loading, setLoading] = useState(false)
      const [listBuilding, setListBuilding] = useState([])
      const [deviceList, setDeviceList] = useState([])
      const [selectedCompany, setSelectedCompany] = useState(null);
      // const deviceList = [
      //     {
      //         id : 1,
      //         name : 'Facial Recognition (FR) & Quick Response (QR)',
      //     },
      //     {
      //         id : 3,
      //         name : 'Automatic Number Plate Recognition (ANPR)',
      //     }
      // ]

      const [errtext, seterrtext] = useState({
        PersonalDetailsData: {...initialDeviceData},
      });

      console.log(errtext, 'err')
      const getAllVisitors = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}company_list`)
          console.log(response)
          if(response.status === 200){
            setListBuilding(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          console.log(error, 'list devices')
          setLoading(false);
      }
  }

  useEffect(() => {
      if(listBuilding.length > 0){
        setSelectedCompany(listBuilding.find((itm) => itm.id == deviceData?.company_id) || null);
      }
  }, [listBuilding]);

  console.log(selectedCompany, 'selectedCompany')

      const getDeviceTypes = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}list_camera_type`)
          console.log(response)
          if(response.status === 200){
            setDeviceList(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          console.log(error, 'list devices')
          setLoading(false);
      }
  }
  
    useEffect(() => {
      getAllVisitors();
      // getDeviceTypes()
    }, []);


     const handlePersonalDetails = (e, name) => {
  if (name) {
    // case for components like DatePicker or Select
    setPersonalDetailsData((prev) => ({
      ...prev,
      [name]: e,
    }));

    seterrtext((prev) => ({
      ...prev,
      PersonalDetailsData: {
        ...prev.PersonalDetailsData,
        [name]: e ? "" : "This field is required",
      },
    }));
  } else {
    const { name, value } = e.target;

    setPersonalDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));

    seterrtext((prev) => ({
      ...prev,
      PersonalDetailsData: {
        ...prev.PersonalDetailsData,
        [name]: value.trim() === "" ? "This field is required" : "",
      },
    }));
  }
};

useEffect(() => {
  if(userDetails.user_role == '5'){
    setPersonalDetailsData((prev) => ({
      ...prev,
      role_id : '5'
    }))
    setSelectedCompany(listBuilding.find((itm) => itm.id == userDetails?.company_id) || null);
  }
}, [userDetails, listBuilding])


const validatePersonalDetails = () => {
  const newErrors = {};

  if (!PersonalDetailsData.name.trim()) {
    newErrors.name = "Name is required";
  }else if (PersonalDetailsData.name.length > 70) {
  newErrors.name = "Name must be 70 characters or less";
}

  if (!PersonalDetailsData.role_id) {
    newErrors.role_id = "Role is required";
  }

  if (!PersonalDetailsData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(PersonalDetailsData.email)) {
    newErrors.email = "Enter a valid email";
  }

  if (!PersonalDetailsData.phone.trim()) {
  newErrors.phone = "Phone number is required";
} 

// else if (!/^65\d{8}$/.test(PersonalDetailsData.phone)) {
//   newErrors.phone = "Enter a valid Singapore number (e.g. 65XXXXXXXX)";
// } 
  // else if (!/^[0-9]{10}$/.test(PersonalDetailsData.phone)) {
  //   newErrors.phone = "Enter a valid 10-digit phone number";
  // }

  // if (PersonalDetailsData.role_id != '2' && !selectedCompany) {
  //   newErrors.company = "Company is required";
  // }

  // Update the error state
  seterrtext((prev) => ({
    ...prev,
    PersonalDetailsData: {
      ...prev.PersonalDetailsData,
      ...newErrors,
    },
  }));

  // If no errors, return true
  return Object.keys(newErrors).length === 0;
};

console.log(selectedCompany)

      const saveDevice = async () => {
         if (validatePersonalDetails()) {
         
          setLoading(true)
          if(id){
             try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}update_user/${id}?updater_email=${userDetails?.email}`, {
                  ...PersonalDetailsData,
                  created_by : userDetails.id,
                  ...(PersonalDetailsData.role_id != '2' && {
                      company_id : selectedCompany?.id || null,
                  }),
              })
              console.log(response)
              if(response?.data?.status === 200){
                  console.log('created')
                  toast.success("User Updated Successfully")
                  setTimeout(() => {
                      navigate('/user_list')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              console.log(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          } else {
            let obj = {}
            if(userDetails.user_role == '5'){
              obj = {
                ...PersonalDetailsData,
                role_id : 5,
                created_by : userDetails.id,
                company_id : userDetails.company_user_id,
              }
            } else {
              obj = {
                ...PersonalDetailsData,
                created_by : userDetails.id,
              }
            }
             try {
              const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}create_user?creator_email=${userDetails?.email}`, {
                  ...obj,
              })
              console.log(response)
              if(response?.data?.status === 201){
                  console.log('created')
                  toast.success("User Created Successfully")
                  setTimeout(() => {
                      navigate('/user_list')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              console.log(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          }
         }
      }



  return (
      <>
      <ToastContainer
                  autoClose='3000'
                  position="bottom-center"
                  toastClassName="custom-toast"
                  hideProgressBar={true}
                />
    <Box
          mt={3}
          component="div"
        //   boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>User Details</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px  ",
            }}
          >
            <Grid xs={12} sm={5.8}>
              <StyledTypography>Name</StyledTypography>
              <TextField
                name="name"
                value={PersonalDetailsData.name}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.name}
              </ErrorTypography>
            </Grid>
            <Grid xs={12} sm={5.8}>
              <StyledTypography>Email</StyledTypography>
              <TextField
                name="email"
                value={PersonalDetailsData.email}
                onChange={handlePersonalDetails}
                disabled={id ? true : false}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 100 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.email
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.email
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.email}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
  <StyledTypography>Phone</StyledTypography>

  <PhoneInput
    country={"sg"}
    value={PersonalDetailsData.phone}
    onChange={(phoneValue) => handlePersonalDetails(phoneValue, "phone")}
    inputStyle={{
      width: "100%",
      height: "56px",
      backgroundColor: errtext.PersonalDetailsData.phone
        ? "#FEE4E2"
        : "#F9FAFB",
      border: "0px solid #D0D5DD",
      borderRadius: "8px",
      color: errtext.PersonalDetailsData.phone ? "#912018" : "#111927",
      fontSize: "16px",
      paddingLeft: "48px",
    }}
    buttonStyle={{
      border: "0px solid #D0D5DD",
      backgroundColor: "#F9FAFB",
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
    }}
    specialLabel="" // removes default label
    inputProps={{ maxLength: 20 }}
  />

  <ErrorTypography>
    {errtext.PersonalDetailsData.phone}
  </ErrorTypography>
</Grid>

{userDetails?.user_role === 5 && (


<Grid xs={12} sm={5.8} mt={1}>
              <StyledTypography>Role Name</StyledTypography>
              <TextField
                name="sub_user_role"
                value={PersonalDetailsData.sub_user_role}
                onChange={handlePersonalDetails}
                disabled={id ? true : false}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 100 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.sub_user_role
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.sub_user_role
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.sub_user_role}
              </ErrorTypography>
            </Grid>
            )}


            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>
                Address
              </StyledTypography>
              <TextField
                name="address"
                value={PersonalDetailsData.address}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !No_special_regex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 25 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.address}
              </ErrorTypography>
            </Grid> */}
              
              {userDetails.user_role != '5' && (

              
              <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Role</StyledTypography>
              <Select
                name="role_id"
                value={PersonalDetailsData.role_id}
                onChange={(e) => handlePersonalDetails(e)}
                disabled={userDetails.user_role == '5' ? true : false}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.role_id
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.role_id
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {/* <MenuItem value={`2`}>{`BMO Admin`}</MenuItem> */}
                <MenuItem value={`3`}>{`Concierge`}</MenuItem>
                <MenuItem value={`4`}>{`Security`}</MenuItem>
                {/* <MenuItem value={`5`}>{`Manager`}</MenuItem> */}
                {/* {listBuilding.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.building_name}</MenuItem>;
                })} */}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.role_id}
              </ErrorTypography>
            </Grid>
            )}
            
            {/* {PersonalDetailsData.role_id != '2' && (
            <Grid xs={12} sm={12} mt={2}>
                          <StyledTypography>Select Company</StyledTypography>
                          <Autocomplete
                          // disabled={id ? true : false}
                  options={listBuilding}
                  disabled={userDetails.user_role == '5' ? true : false}
                  getOptionLabel={(option) =>
                    `${option.name} | ${option.email}`
                  }
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined"
                    sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.company
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.company
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }} />
                  )}
                  onChange={(event, value) => {
                    setSelectedCompany(value)
                    seterrtext((prev) => ({
                      ...prev,
                      PersonalDetailsData: {
                        ...prev.PersonalDetailsData,
                        company: value ? "" : "Company is required",
                      },
                    }));
                  }}
                  value={selectedCompany}
                  sx={{ width: '100%' }}
                />
                          <ErrorTypography>
                            {errtext.PersonalDetailsData.company}
                          </ErrorTypography>
                        </Grid>
                         )} */}
            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Device Type</StyledTypography>
              <Select
                name="type"
                value={PersonalDetailsData.type}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.type
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.type
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {deviceList.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.title}</MenuItem>;
                })}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.type}
              </ErrorTypography>
            </Grid> */}

            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Port</StyledTypography>
              <TextField
                name="port"
                value={PersonalDetailsData.port}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.port}
              </ErrorTypography>
            </Grid> */}

          
            
           
          </Grid>

            <Box bgcolor="#FFFFFF" sx={{ border: "1px solid #E5E7EB", borderRadius: '8px 8px 8px 8px', mt : 2 }}>
                <Stack direction="column" justifyContent='end' alignItems='end' sx={{ py : 2, px : 2, display: 'flex', gap : 2 , flexDirection : { xs : 'column', sm : 'row'} }}>
                    <Button type='button' onClick={() => navigate(-1)} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#f3eae7ff" }}>Back</Button>
                    <Button type='button' disabled={loading} onClick={() => saveDevice()} sx={{ fontWeight: '600', width: "100px", color: 'white', backgroundColor: "#800000", "&:hover": {
      backgroundColor: "#660000",
    },"&.Mui-disabled": {
      backgroundColor: "#C4C4C4",
      color: "#6B7280",
      cursor: "not-allowed",
    }, }}>{id ? "Update" : "Create"}</Button>
                </Stack>
            </Box>
        </Box>
        </>
  )
}

export default AddUser